var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirNotHeardLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 2.5L2 37.5M2 2.5L37 37.5",
    stroke: "#1265A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0095 48.4806C47.1141 48.4862 48.0141 47.5953 48.0197 46.4908L48.1116 28.491C48.1172 27.3865 47.2264 26.4865 46.1218 26.4808C45.0173 26.4752 44.1173 27.3661 44.1117 28.4706L44.03 44.4704L28.0302 44.3887C26.9256 44.3831 26.0256 45.2739 26.02 46.3785C26.0144 47.483 26.9052 48.383 28.0098 48.3887L46.0095 48.4806ZM37.0608 37.4297L35.6394 38.8367L44.5983 47.8876L46.0197 46.4806L47.4412 45.0736L38.4822 36.0227L37.0608 37.4297Z",
    fill: "#1265A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirNotHeardLeft);
export default __webpack_public_path__ + "static/media/AirNotHeardLeft.606100494db8de4828258cb05633e58e.svg";
export { ForwardRef as ReactComponent };